// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paramstatus {
  border: 1px solid #929292;
  height: 50px;
  width: 100px;
  padding: 1px;
  text-align: center;
  margin-bottom: 1rem;
  margin-left: 1em;
  margin-right: 1em;
}

.icon_picklist-col {
  width: 50%;
  float: left;
  padding: 0 1em;
}

.errspan {
  float: right;
  margin-right: 6px;
  margin-top: -20px;
  position: relative;
  z-index: 2;
  cursor: copy;
}

.layer {
  width: 100%;
  padding: 1px;
}

.constraints-message__warning {
  color: red;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
